import { render } from "./Contenuti.vue?vue&type=template&id=02af2201"
import script from "./Contenuti.vue?vue&type=script&lang=js"
export * from "./Contenuti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__